import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProgressSpinner } from 'primeng/progressspinner';
import { SUiViewFormattedTextComponent } from '../s-ui-view-formatted-text/s-ui-view-formatted-text.component';

@Component({
  selector: 's-ui-page-loading-reactive-prime',
  templateUrl: './page-loading-reactive-prime.component.html',
  styleUrls: ['./page-loading-reactive-prime.component.scss'],
  standalone: true,
  imports: [ProgressSpinner, SUiViewFormattedTextComponent, AsyncPipe]
})
export class PageLoadingReactivePrimeComponent {
  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig
  ) {}
}
